import { createContext } from 'react';

import type { FieldValidationError } from '@/lib/heyapi/types.gen';

export const RatingErrorsContext = createContext<{
  errors: Array<FieldValidationError> | null;
  setErrors: (errors: Array<FieldValidationError> | null) => void;
}>({
  errors: null,
  setErrors: () => {},
});
